import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import Flex from '../../Flex';
import fillArray from '../../../../Util/fillArray';

const createCss = (cols, childSpacing) => {
  return `
    width: ${`calc((100% - (${childSpacing} * ${cols - 1})) / ${cols})`};
    &:nth-child(n) {
      margin-right: ${childSpacing};
    }
    &:nth-child(${cols + 'n'}) {
      margin-right: 0;
    }
  `;
};

const media = (columns, childSpacing, theme) => {
  const css = theme.breakpoints.reduce((acc, currValue, index) => {
    return (
      acc +
      `@media (min-width: ${theme.breakpoints[index]}) {
          ${createCss(columns[index + 1], childSpacing)};
        }
      `
    );
  }, createCss(columns[0], childSpacing));
  return css;
};

const HorizontalList = styled(({ columns, childSpacing, ...props }) => <Flex {...props} />).attrs(
  ({ columns, theme }) => {
    const array = !Array.isArray(columns) ? [columns] : columns;
    const outColumns = fillArray(array, theme.breakpoints.length + 1, array[array.length - 1]);
    return {
      columns: outColumns,
    };
  }
)`
  ${({ childSpacing, columns, theme }) => {
    return css`
      && {
        flex-wrap: wrap;
        > * {
          margin-right: ${childSpacing};

          /* width and margin of component in different medias. */
          ${(props) => media(columns, childSpacing, theme)};
        }
      }
    `;
  }}
`;

HorizontalList.propTypes = {
  columns: PropTypes.oneOfType([PropTypes.number, PropTypes.array]),
  childSpacing: PropTypes.string,
};

HorizontalList.defaultProps = {
  columns: [1],
  childSpacing: '32px',
};

export { HorizontalList };
export default HorizontalList;
